import React from 'react';

import { isNotNil } from 'es-toolkit';
import { isEmpty } from 'es-toolkit/compat';

import { Nullable } from '@clearverify/types';

import { EmployersTableListQueryVariables, EmployerWhere } from 'src/api';
import { useFilterStorage, useSearchQueryVariables } from 'src/hooks/common';
import {
  prepareEmployerSearchFilterByCategories,
  prepareEmployersFilterByStatus,
} from 'src/utils/employer';
import { gql } from 'src/utils/gql';

export const useEmployersUnderPEOPayrollProviderQueryVariables = (
  peoPayrollProviderId: Nullable<string>,
) => {
  const searchQueryVariables = useSearchQueryVariables(prepareEmployerSearchFilterByCategories);
  const { filter, sortQueryVariable, paginationQueryVariables } = useFilterStorage();

  const peoPayrollProviderFilter: EmployerWhere = React.useMemo(
    () => ({
      OR: [
        {
          peo: {
            peoPayrollProviderId: { equals: peoPayrollProviderId },
          },
        },
        {
          peoPayrollProviderId: { equals: peoPayrollProviderId },
        },
      ],
    }),
    [peoPayrollProviderId],
  );

  const queryVariables: EmployersTableListQueryVariables = React.useMemo(() => {
    return {
      filter: gql.wrapToAND(
        [searchQueryVariables, peoPayrollProviderFilter, prepareEmployersFilterByStatus(filter)]
          .filter(isNotNil)
          .filter(item => !isEmpty(item)),
      ),
      ...paginationQueryVariables,
      orderBy: sortQueryVariable,
    };
  }, [
    searchQueryVariables,
    peoPayrollProviderFilter,
    filter,
    paginationQueryVariables,
    sortQueryVariable,
  ]);

  return queryVariables;
};
